import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';
import { useContextProperties } from 'contexts/properties';

import usePlacesProvider from 'dataProvider/hooks/usePlacesProvider';
import useResultProvider from 'dataProvider/hooks/useResultProvider';
import useDebounce from 'dataProvider/hooks/useDebounce';
import LoadingPlaceholder from 'components/loadingPlaceholder';
import { useContextCurrentSite } from 'contexts';
import { getPlace } from '../../dataProvider';
import { TYPES, SUBTYPES } from '../../envs';

import PactometroCheckSimple from '../../components/pactometroCheck/pactometroCheckSimple';

import TableRanking from '../../components/tableRanking';

import './rankingPactometro.scss';
import { getSite, LOCALHOST } from '../../constants/sites';

import { excludedGrandParentIds } from '../../core/constants';
import { Autocomplete, MasterBar } from '../../components';

const selecteds = [];
const RankingPactometro = ({ history }) => {
  const { matchParams } = useContextMatchParams();
  const { year, type, electionNumber, placeId, showMasterBar } = matchParams;

  const { params } = useContextProperties();
  const resultOrigin = useContextResultOrigin();

  // const Cintillo = cintillos[place];

  const [autocompleCom, setAutocompleCom] = useState('');
  const [place, setPlace] = useState(null);
  const [autocompleMun, setAutocompleMun] = useState('');

  const { currentSite } = useContextCurrentSite();

  const site = getSite();

  getPlace({
    filter: `sortby=main&size=1&addid=${placeId}`,
    type,
    electionType: type
  }).then(_place => {
    setPlace(_place.content[0]);
  });

  const { result: dataResult } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.primary?.active,
    year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber,
    placeId: type === TYPES.GENERAL ? 'C108' : placeId,
    site: site === LOCALHOST ? currentSite : site
  });

  const { result: oldData } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.historic?.active,
    year: resultOrigin?.historic?.year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber: resultOrigin?.historic?.numElection,
    placeId: type === TYPES.GENERAL ? 'C108' : placeId,
    site: site === LOCALHOST ? currentSite : site
  });

  const { result: dataPlacesRegion } = usePlacesProvider({
    type: 'REGION',
    sortby: 'name',
    excludedGrandParentIds,
    electionType: type
  });

  const debouncedSearch = useDebounce(autocompleMun, 400);
  const { result: dataPlacesTown } = usePlacesProvider({
    sortby: 'name',
    name: debouncedSearch,
    type: 'TOWN',
    size: 10,
    electionType: type
  });

  if (
    !dataResult ||
    !oldData ||
    !dataPlacesRegion ||
    (type !== TYPES.GENERAL && !place) ||
    !dataPlacesTown
  ) {
    return <LoadingPlaceholder />;
  }

  let leyenda = '';
  if (type === TYPES.MUNICIPAL) {
    if (placeId === '04013') {
      leyenda = '* CON ANDALUCÍA se compara con PODEMOS';
    }

    // Barcelona Cs compara con Barcelona  Percami ciutadans
    if (placeId === '08019') {
      leyenda =
        '* CS se compara con Barcelona pel Canvi-Ciutadans y TRIASXBCN se compara con JUNTS';
    }

    // en ceuta se compara Ceuta Ya con caballas
    if (placeId === '51001') {
      leyenda = '* CEUTA YA! se compara con CABALLAS';
    }

    // Cordoba CONAND compara con podemos
    if (placeId === '14021') {
      leyenda = '* CON ANDALUCÍA se compara con PODEMOS';
    }

    // Gijon  Convocatoria por gijon de iu
    if (placeId === '33024') {
      leyenda = '* CONVOCATORIA POR GIJÓN se compara con IU';
    }

    // Hospitalet de llobregat
    if (placeId === '08101') {
      leyenda = '* EN COMÚ PODEM se compara con LHECP-ECG';
    }
    // logroño
    if (placeId === '26089') {
      leyenda = '* UNIDAS se compara con PODEMOS ';
    }
  }

  return (
    <div className="rankingPactometroPage">
      <MasterBar
        optionalTitleRegular={
          params.sites[site === LOCALHOST ? currentSite : site].labels.ranking
        }
        optionalTitleStrong={
          params.sites[site === LOCALHOST ? currentSite : site].labels
            .ranking_strong
        }
        isOpenedTabs={false}
      />
      <div className="rankingPactometroWrapper">
        {type !== TYPES.GENERAL && (
          <div className="rankingHeader-data">
            <div className="wrapper-autocomplete">
              {dataPlacesRegion && type === TYPES.REGIONAL && (
                <Autocomplete
                  results={dataPlacesRegion.filter(d =>
                    autocompleCom
                      ? d.name
                          .toLocaleLowerCase()
                          .includes(autocompleCom.toLocaleLowerCase())
                      : d
                  )}
                  onChange={value => setAutocompleCom(value)}
                  onSelect={(event, select) => {
                    event.preventDefault();
                    event.stopPropagation();
                    history.push(
                      `/0/${year}/${type}/${electionNumber}/${showMasterBar}/${select.ineId}/rankingPactometro.html`
                    );
                  }}
                  placeholder="Seleccione comunidad"
                  showArrow
                  type={type}
                  params={params}
                  year={year}
                />
              )}
              {dataPlacesRegion && type === TYPES.MUNICIPAL && (
                <Autocomplete
                  results={dataPlacesTown}
                  onChange={value => setAutocompleMun(value)}
                  onSelect={(event, select) => {
                    event.preventDefault();
                    event.stopPropagation();
                    history.push(
                      `/0/${year}/${type}/${electionNumber}/${showMasterBar}/${select.ineId}/rankingPactometro.html`
                    );
                  }}
                  placeholder="Buscar municipio"
                  showArrow
                  type={type}
                  params={params}
                  year={year}
                />
              )}
            </div>
            <h3 className="ranking-place-title">{place?.name ?? 'España'}</h3>
          </div>
        )}
        <div className="rankingWrapper">
          <TableRanking
            currentData={dataResult}
            pastData={oldData}
            year={year}
            electionNumber={electionNumber}
            electionType={type}
            placeId={placeId}
            titleColumn={dataResult.year}
            titleColumn2={oldData.year}
          />
          <p className="ranking-leyend">
            {/* * En 2018, Por Andalucía y Adelante Andalucía concurrieron juntos */}
          </p>
        </div>
        <div className="pactometroWrapper">
          {dataResult.partiesResult && (
            <PactometroCheckSimple
              selecteds={selecteds}
              totalSeat={dataResult.totalSeats}
              seatData={dataResult.partiesResult}
              legend={`*Pincha sobre cada partido para sumar sus ${
                type === TYPES.MUNICIPAL ? 'concejales' : 'escaños'
              } `}
              legend2={leyenda}
              type={type}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RankingPactometro;

RankingPactometro.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};
